import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

/**
 * Initialize i18next with HTTP backend for loading translation files.
 * Call this before rendering the React tree.
 */
// Own-origin base so the embedded remote loads locales from its deployment, not the host page
const localesBase = new URL(import.meta.env.BASE_URL, import.meta.url).href.replace(/\/?$/, '/');

export async function initI18n() {
  await i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      supportedLngs: ['en'],
      load: 'languageOnly',
      defaultNS: 'common',
      ns: ['common', 'campaigns', 'analytics'],
      interpolation: {
        escapeValue: false, // React already escapes
      },
      backend: {
        loadPath: `${localesBase}locales/{{lng}}/{{ns}}.json`,
      },
      detection: {
        order: ['navigator'],
        caches: [],
      },
    });
}

/**
 * The initialized i18next instance for use in providers.
 */
export const i18n = i18next;
